import { Injectable } from '@angular/core';

export interface ThemeColors {
  primerColor: string;
  segundoColor: string;
  tercerColor: string;
  colorTexto: string;
  pieColor: string;
  pieColorTexto: string;
  sombraColor: string;
  navbarColorFondo: string;
  navbarColorBotones: string;
  navbarColorTexto: string;
  accentColor?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  applyTheme(colores: ThemeColors): void {
    const rootElement = document.documentElement;
    // Fuente única de verdad: cada color se setea una sola vez. Los alias legacy
    // (--first-ecommerce-color, --foo-ecommerce-color, --primary-color, etc.)
    // están definidos en styles.scss/mixin.scss como var(...) de estos mismos valores,
    // así que no hace falta (ni conviene) setearlos también acá.
    rootElement.style.setProperty('--primerColor', colores.primerColor);
    rootElement.style.setProperty('--segundoColor', colores.segundoColor);
    rootElement.style.setProperty('--tercerColor', colores.tercerColor);
    rootElement.style.setProperty('--colorTexto', colores.colorTexto);
    rootElement.style.setProperty('--pieColor', colores.pieColor);
    rootElement.style.setProperty('--pieColorTexto', colores.pieColorTexto);
    rootElement.style.setProperty('--sombraColor', colores.sombraColor);
    rootElement.style.setProperty('--navbarColorFondo', colores.navbarColorFondo);
    rootElement.style.setProperty('--navbarColorBotones', colores.navbarColorBotones);
    rootElement.style.setProperty('--navbarColorTexto', colores.navbarColorTexto);
    rootElement.style.setProperty('--accentColor', colores.accentColor || colores.segundoColor);
  }
}
